"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Buy Now Button',
  description: "\n  Choose if you want to have a \"Buy Now\" for each item (you can edit the text on the button using the \"customButtonText\" option).",
  isRelevant: function isRelevant() {
    return true;
  },
  type: _constants.INPUT_TYPES.BOOLEAN,
  "default": false
};
exports["default"] = _default;